import { CgClose } from "react-icons/cg";

function ModalTitle({ title, closeModal }) {
    return (
        <div className="flex flex-row-reverse items-center justify-between
                         bg-purpleDark rounded-t-lg text-white py-3 px-4 shadow">
            <p className="mr-2">{title}</p>
            <CgClose
                size={21}
                onClick={closeModal}
            />
        </div>
    )
}
export default ModalTitle;